<template>
	<div class="input-code-editor">
		<label v-if="label" class="v-label theme--light">{{ label }}</label>
		<div ref="editor" class="code-editor-wrapper"></div>
	</div>
</template>

<script>
import CodeMirror from 'codemirror'
import 'codemirror/mode/css/css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'

export default {
	props: {
		value: {
			type: String,
			default: '',
		},
		label: String,
		mode: {
			type: String,
			default: 'css',
		},
	},
	data() {
		return {
			editor: null,
		}
	},
	watch: {
		value(newValue) {
			if (this.editor && this.editor.getValue() !== newValue) {
				this.editor.setValue(newValue || '')
			}
		},
	},
	mounted() {
		this.editor = CodeMirror(this.$refs.editor, {
			value: this.value || '',
			mode: this.mode,
			theme: 'monokai',
			lineNumbers: true,
			lineWrapping: true,
			indentUnit: 2,
			tabSize: 2,
			indentWithTabs: false,
		})

		this.editor.on('change', () => {
			this.$emit('input', this.editor.getValue())
			this.$emit('change', this.editor.getValue())
		})
	},
	beforeDestroy() {
		if (this.editor) {
			// Cleanup CodeMirror instance
			// CodeMirror 5: Get the wrapper element and remove it
			try {
				const wrapper = this.editor.getWrapperElement()
				if (wrapper && wrapper.parentNode) {
					wrapper.parentNode.removeChild(wrapper)
				}
			} catch (e) {
				// Fallback: clear the ref element's content
				const wrapper = this.$refs.editor
				if (wrapper) {
					wrapper.innerHTML = ''
				}
			}
			// Clear the editor reference
			this.editor = null
		}
	},
}
</script>

<style scoped>
.input-code-editor {
	margin-bottom: 16px;
}

.input-code-editor >>> .v-label {
	font-size: 12px;
	margin-bottom: 8px;
	display: block;
}

.code-editor-wrapper {
	border: 1px solid rgba(0, 0, 0, 0.38);
	border-radius: 4px;
	overflow: hidden;
}

.code-editor-wrapper >>> .CodeMirror {
	height: auto;
	min-height: 200px;
	font-size: 12px;
	font-family: 'Courier New', Courier, monospace;
}

.code-editor-wrapper >>> .CodeMirror-scroll {
	min-height: 200px;
	max-height: 600px;
}
</style>
